<template>


    <div class="container container-tabs">

        <div class="handle-box-search">

            <el-row class="head-search">

                <el-col :span="8">

                    <span class="title">司机姓名:</span>
                    <el-input v-model="search_data.driver_name" placeholder="请输入司机名称" class="handle-input mr10"
                              @keyup.enter.native="searchdriverOrderCountLists"></el-input>

                </el-col>


                <el-col :span="8">

                    <span class="title">司机电话:</span>
                    <el-input v-model="search_data.driver_phone" placeholder="请输入司机电话" class="handle-input mr10" maxlength="11"
                              @keyup.enter.native="searchdriverOrderCountLists"></el-input>

                </el-col>

                <el-col :span="24">

                    <el-col :span="8" style="margin-top: 10px">

                        <span class="title">注册时间:</span>

                        <el-date-picker v-model="search_time" type="datetimerange" range-separator="-" start-placeholder="开始日期"
                                        end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"
                                        style="width: 300px;">
                        </el-date-picker>

                    </el-col>



                </el-col>



            </el-row>





            <div>

                <el-button type="primary" icon="el-icon-search" @click="searchdriverOrderCountLists">搜索</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                <el-button v-if="excelBtn_isShow == 1" :icon="progress_show?'el-icon-loading':'el-icon-setting'" @click="toExport" :disabled="progress_show">{{progress_show?'导出中...':'导出'}}</el-button>
            </div>

        </div>


        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">



            <el-table-column prop="real_name" label="司机名称" min-width="150">
            </el-table-column>、
            <el-table-column prop="phone" label="司机电话" min-width="150">
            </el-table-column>
            <el-table-column prop="count_num" label="当日单量" min-width="150">
            </el-table-column>
            <el-table-column prop="sum_num" label="当日金额" min-width="150">
            </el-table-column>

            <el-table-column prop="online_time" label="在线时长" min-width="150">
            </el-table-column>





            <el-table-column prop="today_time" label="日期" min-width="150">
            </el-table-column>








        </el-table>


        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>



        <!-- 审核组件 -->
        <!--        <toExamine :isShow="toExamine_isShow" :data="toExamine" @onSubmit="driverPromoteLists">-->
        <!--        </toExamine>-->


    </div>


</template>

<script>
    import axios from 'axios';
    import { config } from '../../../utils/config';

    var _this;
    // import toExamine from './toExamine.vue';


    export default {
        components: {

            // toExamine

        },
        data() {
            return {


                // 传入子组件的数据
                toExamine: '',

                search_time: '',

                progress_show:false,

                excelData: [],

                excelHead: [],

                city_data:[],

                excelBtn_isShow:JSON.parse(localStorage.getItem('login')).export_order_count,


                driver_recruit_city_all:JSON.parse(localStorage.getItem('login')).driver_recruit_city_all,



                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    driver_phone: '',
                    driver_name:'',
                    fixed_array:'',
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                },
            };
        },
        created() {
            _this = this;
            _this.driverOrderCountLists();
        },

        methods: {
            toExport() {


                _this.getExcelData();

            },

            getExcelData() {

                _this.$post(
                    "/driver/exportDriverOrderCountListsCSV",{
                        page:_this.search_data.page,
                        driver_phone:_this.search_data.driver_phone,
                        driver_name:_this.search_data.driver_name,
                        fixed_array:_this.search_data.fixed_array,
                    }

                ).then(res => {

                    _this.progress_show = true;

                    if (this.$route.path == '/driverOnline') {

                        console.log(res.data);
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.result.length; i++) {

                            _this.excelData.push({
                                'real_name': res.data.result[i].real_name,
                                'phone': res.data.result[i].phone,
                                'count_num': res.data.result[i].count_num,
                                'sum_num': res.data.result[i].sum_num,
                                'online_time': res.data.result[i].online_time,
                                'today_time': res.data.result[i].today_time

                            });


                        }



                        if (res.data.page * res.data.limit < res.data.count) {

                            _this.search_data.page = res.data.page + 1;

                            // _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

                            _this.getExcelData();

                        } else {

                            console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;


                        }

                    } else {

                        _this.progress_show = false;

                    }



                }).catch((err) => {

                })

            },

            // 导出excel方法
            exportData() {
                const {
                    export_json_to_excel
                } = require('@/vendor/Export2Excel');
                const tHeader = ['司机名称', '司机电话', '当日单量', '当日金额', '在线时长', '日期'];
                const filterVal = ['real_name', 'phone','count_num', 'sum_num', 'online_time', 'today_time'];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, 'fileName');
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            timeChange(val) {
                if(val !== null){
                    _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));

                }else{
                    _this.search_data.fixed_array = ''
                }

            },

            searchdriverOrderCountLists(){
                _this.search_data.page = 1;
                _this.driverOrderCountLists();
            },



            // 搜索司机列表
            driverOrderCountLists() {
                _this.$post(
                    "/driver/driverOrderCountLists",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {

                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;


                    }).catch((err) => {

                })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.driverOrderCountLists();

            },

            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        max-width: 150px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown+.el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>
